var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 33,
    fill: "none",
    strokeWidth: 0.25,
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.958 1l-13.134 9.718 2.442-5.727L32.958 1z",
    fill: "#e17726",
    stroke: "#e17726"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e27625",
    stroke: "#e27625"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.662 1l13.017 9.809-2.325-5.818L2.662 1zm25.567 22.533l-3.495 5.339 7.483 2.06 2.144-7.282-6.132-.117zm-26.956.117l2.131 7.282 7.47-2.06-3.482-5.339-6.119.117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.471 14.515l-2.079 3.136 7.405.337-.247-7.969-5.08 4.496zm14.68 0l-5.157-4.587-.169 8.06 7.405-.337-2.079-3.136zM10.873 28.872l4.482-2.164-3.858-3.006-.624 5.17zm9.393-2.164l4.469 2.164-.611-5.17-3.858 3.006z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.735 28.872l-4.469-2.164.364 2.903-.039 1.231 4.144-1.97zm-13.862 0l4.157 1.97-.026-1.231.351-2.902-4.482 2.164z",
    fill: "#d5bfb2",
    stroke: "#d5bfb2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.108 21.784l-3.716-1.088 2.624-1.205 1.091 2.293zm5.406 0l1.091-2.293 2.637 1.205-3.729 1.088z",
    fill: "#233447",
    stroke: "#233447"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.872 28.872l.65-5.339-4.131.117 3.482 5.222zm13.226-5.339l.637 5.339 3.495-5.222-4.131-.117zm3.131-5.882l-7.405.337.688 3.797 1.091-2.294 2.637 1.205 2.988-3.045zm-15.835 3.045l2.624-1.205 1.091 2.294.688-3.797-7.405-.337 3.001 3.045z",
    fill: "#cc6228",
    stroke: "#cc6228"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.393 17.651l3.105 6.051-.104-3.006-3.001-3.045zm15.849 3.045l-.117 3.006 3.105-6.051-2.988 3.045zm-8.444-2.708l-.689 3.797.87 4.483.195-5.909-.377-2.371zm4.027 0l-.364 2.358.182 5.922.87-4.483-.689-3.797z",
    fill: "#e27525",
    stroke: "#e27525"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.513 21.784l-.87 4.483.624.441 3.858-3.006.117-3.006-3.728 1.089zm-9.12-1.088l.104 3.006 3.858 3.006.624-.441-.87-4.483-3.716-1.089z",
    fill: "#f5841f",
    stroke: "#f5841f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 30.842l.039-1.231-.338-.285h-4.963l-.325.285.026 1.231-4.157-1.97 1.455 1.192 2.949 2.034h5.054l2.962-2.034 1.442-1.192-4.144 1.97z",
    fill: "#c0ac9d",
    stroke: "#c0ac9d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.265 26.708l-.624-.441h-3.664l-.623.441-.351 2.903.325-.285h4.963l.338.285-.364-2.903z",
    fill: "#161616",
    stroke: "#161616"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.517 11.353l1.104-5.364L32.958 1l-12.692 9.394 4.885 4.121 6.898 2.008 1.52-1.775-.663-.479 1.052-.959-.805-.622 1.052-.803-.689-.531zM1 5.989l1.117 5.364-.715.531 1.065.803-.805.622 1.052.959-.663.479 1.52 1.775 6.898-2.008 4.885-4.121L2.663 1 1 5.989z",
    fill: "#763e1a",
    stroke: "#763e1a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.05 16.523l-6.898-2.008 2.079 3.136-3.105 6.051 4.105-.052h6.132l-2.312-7.127zm-21.579-2.008l-6.898 2.008-2.299 7.127h6.119l4.105.052-3.105-6.051 2.079-3.136zm9.354 3.473l.442-7.593 2.001-5.403h-8.912l2.001 5.403.442 7.593.169 2.384.013 5.896h3.664l.013-5.896.169-2.384z",
    fill: "#f5841f",
    stroke: "#f5841f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmLogo);
export default __webpack_public_path__ + "static/media/mm_logo.15ebc6938c6c88702db25c01611b5244.svg";
export { ForwardRef as ReactComponent };